import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Box, Typography, Button } from "@mui/material";
import PointBox from '../components/PointBox';
import PointSolidSheet from '../components/PointSolidSheet';
import ReadyStart from '../screens/ReadyStart';
import SheetPoint from '../components/SheetPoint';

import chargingEV7Img from "../assets/images/charging-ev-7.svg";
import chargingEV8Img from "../assets/images/charging-ev-8.svg";
import chargingEV9Img from "../assets/images/charging-ev-9.svg";

import DollarIcon from "../assets/icons/dollar-icon.svg";
import BoltIcon from "../assets/icons/bolt-spark.svg";
import IntersectionWithCarImage from "../assets/images/intersection-with-cars.svg";
import TimeRollIcon from "../assets/icons/time-roll.svg";
import CancelIcon from "../assets/icons/cancel-icon.svg";
import LeafIcon from "../assets/icons/leaf-icon.svg";

import MapIcon from "../assets/icons/map-icon.svg";
import CheckMobileIcon from "../assets/icons/phone-check.svg";
import StatIcon from "../assets/icons/stat-icon.svg";
import ChargeStationIcon from '../assets/icons/charge-station.svg';

function WhySplitevPage() {
  return (
    <>
      {/* HEADER HERE */}
      <NavBar />

      {/* DRIVERS PAGE CONTENT HERE */}
      <Box sx={{
        padding: "6.4rem",
        px: { xs: '2rem', sm: '2rem', md: '6.4rem', lg: '6.4rem' },
        background: 'linear-gradient(264.22deg, #181A18 -124.15%, #0C0D0C 52.54%, #181A18 200.05%)',
      }}>
        {/* HERO SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "4rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "fit-content",
          margin: { xs: "2rem auto", sm: "2rem auto" },
        }}>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: 'space-between',
              textAlign: { xs: "center", md: "left" },
              gap: "3.5rem",
              width: { xs: "100%", md: "50%" },
            }}
          >

            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '4rem', sm: '5rem', md: '5.6rem' },
                fontWeight: 900,
                lineHeight: { xs: '4rem', sm: '5rem', md: '6rem' },
                maxWidth: '25ch',
              }}
            >
              Why SplitEV
            </Typography>

            <Typography
              sx={{
                color: "littleWhite",
                fontSize: '1.8rem',
                fontWeight: 400,
                maxWidth: '65ch',
              }}
            >
              A smarter, more flexible alternative to public charging.
            </Typography>

            {/* <Box sx={{
              display: "flex",
              gap: "1.5rem",
              flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" },
              alignItems: { xs: 'center', sm: 'left' },
              width: "100%",
              mx: { xs: "auto", sm: "0px", md: "0px" }
            }}>
              <Button
                onClick={() => {
                }}

                sx={{
                  backgroundColor: "white",
                  height: "4.8rem",
                  borderRadius: "25px",
                  color: "black",
                  fontSize: "1.8rem",
                  fontWeight: 700,
                  textTransform: "none",
                  p: '1.2rem 2.4rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '1rem',
                  width: { xs: "100%", sm: "fit-content" },
                }}
              >
                Get started
              </Button>

              <Box
                component="a"
                sx={{
                  color: 'white',
                  fontSize: '1.8rem',
                  fontWeight: 500,
                  ":hover": {
                    cursor: "pointer",
                    textDecoration: "underline",
                  }
                }}>
                Already have an account? Sign in
              </Box>
            </Box> */}
          </Box>

          <Box sx={{ display: "flex", alignItems: "right", justifyItems: "right" }}>
            <Box
              component="img"
              src={chargingEV7Img}
              alt=""
              sx={{
                objectFit: "contain",
                width: { sm: "100%", md: "100%" },
                overflow: "hidden",
                borderRadius: "25px"
              }}
            />
          </Box>
        </Box>

        {/* FUTURE OF EV SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column-reverse', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "fit-content",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>

          <Box sx={{ display: "flex", alignItems: "right", justifyItems: "right" }}>
            <Box
              component="img"
              src={chargingEV8Img}
              alt="Apple logo"
              sx={{
                objectFit: "contain",
                width: { sm: "100%", md: "100%" },
                height: { xs: "24rem", sm: "42rem" },
                borderRadius: "25px"
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              The future of EV charging.
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box
                sx={{
                  listStyle: "none",
                  color: "paleWhite",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem"
                }}
                component="ol"
              >
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  The electric vehicle market is growing rapidly, but charging infrastructure hasn’t kept up with demand.
                  Public charging stations, while essential, often come with challenges—long wait times,
                  unpredictable pricing, and unreliable availability.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  Think of SplitEV as the missing piece of the EV charging puzzle: reliable, affordable,
                  and community-driven.
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* OUR PHILOSOPY SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "fit-content",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              textAlign: { xs: "center", md: "left" },
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              Our philosophy
            </Typography>

            <Box sx={{ display: "flex", gap: "1.2rem", flexDirection: "column", textAlign: "left" }}>
              <Box
                sx={{
                  listStyle: "none",
                  color: "paleWhite",
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem"
                }}
                component="ol"
              >
                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  Charging should be accessible, predictable, and seamless.
                  Instead of relying solely on large-scale infrastructure,
                  we empower communities to create a distributed, resilient, and cost-effective EV charging network.
                </Box>

                <Box sx={{ fontSize: "1.8rem", fontWeight: "400", maxWidth: '60ch', }} component="li">
                  It’s not about replacing public infrastructure—it’s about building a more resilient,
                  reliable system that puts drivers first.
                </Box>
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "right", justifyItems: "right" }}>
            <Box
              component="img"
              src={chargingEV9Img}
              alt="Apple logo"
              sx={{
                objectFit: "contain",
                width: { sm: "100%", md: "100%" },
                height: { xs: "24rem", sm: "42rem" },
                borderRadius: "25px"
              }}
            />
          </Box>
        </Box>

        {/* KEY BENEFITS SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '5rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              How SplitEV benefits you & the EV future.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointBox
                image={DollarIcon}
                title="Save money"
                text='Predictable, flat-rate pricing saves drivers up to $1,920 per year.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={CheckMobileIcon}
                title="No more waiting"
                text='Reserve your charger, arrive, and plug in. No lines, no stress.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={MapIcon}
                title="More charging locations"
                text='Homeowners, businesses, and workplaces host chargers, 
                bringing charging access closer to where you live and work.'>
              </PointBox>
            </Box>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: { xs: "100%", sm: "80%" },
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              p: { sm: "auto 15rem" }
            }
            }
          >
            <Box component="li">
              <PointBox
                image={StatIcon}
                title="Sustainable growth"
                text='Solar-powered and private charging hosts make EV ownership greener.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={ChargeStationIcon}
                title="Emergency backup charging"
                text='Even if public stations are full, SplitEV ensures you always have an option.'>
              </PointBox>
            </Box>
          </Box>
        </Box>

        {/* FUTURE OF EV SECTION */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: 'column', sm: 'column', md: 'row' },
          gap: { xs: "7rem", sm: "10rem" },
          justifyItems: "space-around",
          alignItems: "center",
          width: "fit-content",
          margin: { xs: "10rem auto", sm: "12rem auto" },
          my: { xs: '5rem', md: '18rem' },
        }}>
          <Box sx={{ display: "flex", alignItems: "right", justifyItems: "right" }}>
            <Box
              component="img"
              src={IntersectionWithCarImage}
              alt="Intersection With Car Image"
              sx={{
                objectFit: "contain",
                width: { sm: "100%", md: "100%" },
                height: { xs: "24rem", sm: "42rem" },
                borderRadius: "25px"
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "3.2rem",
              height: "fit-content"
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontSize: { xs: '3.4rem', sm: '4.6rem' },
                fontWeight: 700,
                lineHeight: { xs: '5rem', sm: '5.7rem' },
                maxWidth: '24ch',
                textAlign: { xs: 'left' }
              }}
            >
              The best of both worlds
            </Typography>

            <Box
              component="ul"
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                width: "100%",
                p: "2rem 2rem",
                listStyleType: "disc",
                " > *": {
                  fontSize: "1.6rem",
                  fontWeight: "400",
                  maxWidth: "55ch",
                  textAlign: "left",
                },
              }}
            >
              <Box component="li">
                Public charging stations work well for road trips and city centers.
              </Box>

              <Box component="li">
                SplitEV works best for daily charging, workplaces, and home-based solutions.
              </Box>

              <Box component="li">
                EV drivers shouldn’t be forced into a one-size-fits-all charging model.
                By using both public charging and SplitEV, drivers gain flexibility,
                affordability, and true charging freedom.
              </Box>
            </Box>
          </Box>
        </Box>

        {/* SPLITEV VS PUBLIC SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            m: "auto",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
            maxWidth: "115rem",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '2.4rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              SplitEV vs. Public Charging
            </Typography>

            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.75)",
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
                fontWeight: 400,
                m: 'auto',
                lineHeight: '2.2rem',
                width: { xs: '90%', md: '100%' },
                mb: { xs: "1rem", md: "4rem" }
              }}
            >
              Discover why EV drivers are making the switch to SplitEV's superior charging network.
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointSolidSheet
                image={BoltIcon}
                title="SplitEV"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    margin: "auto",
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li">
                    <SheetPoint
                      image={DollarIcon}
                      title="Affordable"
                      text='Flat-rate subscription with predictable pricing'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={TimeRollIcon}
                      title="Convenient"
                      text='Reserve a charger in advance, charge where you live and work'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={MapIcon}
                      title="Availabile"
                      text='Thousands of private, dedicated chargers integrated into communities'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={TimeRollIcon}
                      title="Time Saver"
                      text='No waiting—just plug in and charge'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={ChargeStationIcon}
                      title="Flexibile"
                      text='Charge at homes, workplaces, and community locations.'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={LeafIcon}
                      title="Sustainable"
                      text='Encourages solar-powered and energy-efficient charging'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>

            <Box component="li">
              <PointSolidSheet
                image={MapIcon}
                title="Public Charging"
              >
                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    margin: "auto",
                    gap: "5rem",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Expensive"
                      text='Flat-rate subscription with predictable pricing'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Convenient"
                      text='Reserve a charger in advance, charge where you live and work'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Availabile"
                      text='Thousands of private, dedicated chargers integrated into communities'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Time Saver"
                      text='No waiting—just plug in and charge'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Flexibile"
                      text='Charge at homes, workplaces, and community locations.'>
                    </SheetPoint>
                  </Box>

                  <Box component="li">
                    <SheetPoint
                      image={CancelIcon}
                      title="Sustainable"
                      text='Encourages solar-powered and energy-efficient charging'>
                    </SheetPoint>
                  </Box>
                </Box>
              </PointSolidSheet>
            </Box>
          </Box>
        </Box>

        {/* SMARTER APPROACH SECTION */}
        <Box
          sx={{
            display: "flex",
            overflow: "hidden",
            my: { xs: '5rem', md: '18rem' },
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            width: "100%",
          }}>

          <Box
            sx={{
              alignItems: 'center',
              justifyContent: 'center', textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.6rem' },
                fontWeight: 700,
                my: { xs: '2rem', sm: '2.4rem' },
                m: 'auto',
                lineHeight: '4.5rem',
                width: { xs: '90%', md: '100%' }
              }}
            >
              A smarter approach to charging.
            </Typography>

            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.75)",
                fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
                fontWeight: 400,
                m: 'auto',
                lineHeight: '2.2rem',
                width: { xs: '90%', md: '100%' },
                maxWidth: "65ch",
                mb: { xs: "1rem", md: "2.5rem" }
              }}
            >
              We believe that EV drivers deserve better than the uncertainty of public charging stations.
              Our approach flows naturally with the needs of the EV community:
            </Typography>
          </Box>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(25rem, 1fr))",
              gap: "5rem",
              justifyContent: "start",
              my: "4rem",
            }}
          >
            <Box component="li">
              <PointBox
                image={BoltIcon}
                title="Reliable"
                text='Public charging works for highways and high-traffic areas—SplitEV provides reliable home, 
                work, and community-based charging to fill in the gaps.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={BoltIcon}
                title="Organic expansion"
                text='Public charging depends on large infrastructure projects—SplitEV grows organically 
                through a network of private hosts and businesses.'>
              </PointBox>
            </Box>

            <Box component="li">
              <PointBox
                image={BoltIcon}
                title="Predictable pricing"
                text='Public charging costs fluctuate and may surge—SplitEV offers stable, 
                predictable pricing with subscription-based access.'>
              </PointBox>
            </Box>
          </Box>
        </Box>


      </Box >

      {/* FOOTER SECTION */}

      <ReadyStart
        phrase="Ready to experience better EV charging?"
        subtitle="Join thousands of satisfied EV drivers who've made the switch">
      </ReadyStart>
      < Footer />
    </>
  );
}

export default WhySplitevPage;